import CartItem from "./CartItem";

const MobileCart = ({ items, cost, showImage = true, translateKey }) => {
    return (
        <div>
            {items.map((item) => (
                <CartItem key={item.product.id} item={item} showImage={showImage} translateKey={translateKey} />
            ))}
        </div>
    );
};

export default MobileCart;
